import {apiCall} from "@ui/api/common";

export type TBoatCommon = {
  reg_number?: string | null
	name?: string | null
	boat_type?: string | null
  boat_category?: string | null
	boat_class?: string | null
}
export type TBoatDimensions = {
  length?: number | null
	width?: number | null
	height?: number | null
	draft?: number | null
	fuel_rate?: number | null
	cruising_speed?: number | null
}
export type TBoatDimensionUnits = {
  length_unit?: "m" | "ft"
	width_unit?: "m" | "ft"
	height_unit?: "m" | "ft"
	draft_unit?: "m" | "ft"
	fuel_rate_unit?: "lph" | "lpkm"
	cruising_speed_unit?: "kmph" | "kn"
}
export type TDimensionUnits = TBoatDimensionUnits[keyof TBoatDimensionUnits]
export type TBoatTracking = {
  has_ais?: boolean | null
	mmsi?: number | null
	dest_port?: string | null
}
export type TBoatInfo = TBoatCommon & TBoatDimensions & TBoatDimensionUnits & TBoatTracking

export type TCaptainData = {
  name?: string | null
}

export type TCaptainInfo = {
	email?: string | null
	boat?: TBoatInfo
} & TCaptainData

export type TDictionary = {
	code: string
	desc?: string | null
}

export const getBoatClasses = () => apiCall().get<TDictionary[]>("/member/boat_classes")

export const getBoatTypes = () => apiCall().get<TDictionary[]>("/member/boat_types")

export const getBoatCategories = () => apiCall().get<TDictionary[]>("/member/boat_categories")

export const getCaptainInfo = () => apiCall().get<TCaptainInfo>("/member/captain")

export const updateCaptainData = (data: TCaptainData) => apiCall().post("/member/update_captain", data)

export const updateBoatInfo = (info: TBoatInfo) => apiCall().post("/member/update_boat", info)
